<template>
  <footer>
    <Build class="alert__msg" />
    <div class="container__footer">
      <div class="section section_a">
        <Icon height="38.4" iconColor="#fff" class="main__logo"></Icon>
        <div class="ubication">
          <img
            src="../assets/icon-location.svg"
            alt="location"
            class="icon__ubication"
          />
          <p class="info__ubication">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua
          </p>
        </div>
        <div class="phone">
          <img src="../assets/icon-phone.svg" alt="" class="icon__phone" />
          <a href="tel:+1-543-123-4567">+1-543-123-4567</a>
        </div>
        <div class="email">
          <img src="../assets/icon-email.svg" alt="" class="icon__email" />
          <a href="mailto:example@huddle.com">example@huddle.com</a>
        </div>
      </div>
      <div class="section section_b">
        <ul>
          <li>About Us</li>
          <li>What We Do</li>
          <li>FAQ</li>
        </ul>
      </div>
      <div class="section section_c">
        <ul>
          <li>Career</li>
          <li>Blog</li>
          <li>Contact Us</li>
        </ul>
      </div>
      <div class="section section_d">
        <fa :icon="{ prefix: 'fab', iconName: 'facebook-f' }" />
        <fa :icon="{ prefix: 'fab', iconName: 'twitter' }" />
        <fa :icon="{ prefix: 'fab', iconName: 'instagram' }" />
      </div>
      <div class="copyright">
        <p class="huddle__copyright">
          &copy; Copyright 2018 Huddle. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
</template>
<script>
import Icon from "../components/icons/IconHubble.vue";
import Build from "../components/Build.vue";
export default {
  setup() {},
  components: {
    Icon,
    Build,
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap");
.alert__msg {
  position: absolute;
  width: 90%;
  top: -75px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

footer {
  position: relative;
  margin-top: 135px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background: #00252e;
}

.container__footer {
  font-family: "Open Sans", sans-serif;
  width: 100%;
  position: relative;
  color: white;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.section {
  width: 90%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.section_a {
  gap: 1.5rem;
}

.main__logo {
  margin-top: 150px;
  -webkit-transform: scale(0.75);
  transform: scale(0.75);
  position: relative;
  left: -30px;
}

.section_a a {
  color: white;
  text-decoration: none;
  opacity: 0.9;
}

.ubication,
.phone,
.email {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.icon__ubication {
  width: 40px;
  height: 20px;
}

.icon__ubication,
.icon__phone,
.icon__email {
  margin-right: 25px;
}

.icon__phone,
.icon__email {
  width: 20px;
  height: 18px;
}
.info__ubication {
  font-size: 16px;
  line-height: 30px;
  opacity: 0.9;
}

.section_b {
  margin-top: 45px;
  font-size: 20px;
}

.section_b ul li {
  margin-top: 25px;
  list-style: none;
}

.section_c {
  font-size: 20px;
}

.section_c ul li {
  margin-top: 25px;
  list-style: none;
}

.section_d {
  width: 250px;
  margin-top: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  gap: 1rem;
}

.section_d svg {
  width: 30px;
  height: 30px;
  border: 1.5px solid white;
  padding: 0.4rem;
  border-radius: 50%;
  color: white;
}

.section_d svg:hover {
  color: #ff52bf;
  border: 1px solid #ff52bf;
}

.copyright {
  width: 100%;
  margin-top: 50px;
  margin-bottom: 50px;
  position: relative;
}

.huddle__copyright {
  text-align: center;
  font-size: 11px;
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  opacity: 0.7;
}

/* .section_d .fa-facebook-f {
  padding: 0.5rem 0.7rem;
} */
@media (min-width: 480px) {
  .ubication {
    width: 340px;
  }
}

@media (min-width: 768px) {
  .alert__msg {
    width: 692px;
  }
  .section_b {
    width: 120px;
    position: absolute;
    top: 90px;
    right: 150px;
  }
  .section_c {
    width: 120px;
    position: absolute;
    top: 280px;
    right: 150px;
  }
}

@media (min-width: 1024px) {
  .alert__msg {
    width: 800px;
    height: 200px;
    top: -100px;
  }
  .container__footer {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    padding-bottom: 70px;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .section_a {
    width: 350px;
  }
  .section_b {
    margin-top: 110px;
    width: auto;
    position: static;
  }
  .section_c {
    margin-top: 110px;
    width: auto;
    position: static;
  }
  .copyright {
    position: absolute;
    bottom: 0;
  }
  .huddle__copyright {
    width: 300px;
    position: absolute;
    right: 0;
    left: initial;
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}

@media (min-width: 1200px) {
  .container__footer {
    width: 1200px;
  }
}
</style>
